<script>
import AkLayout from "@components/layout/AkLayout";
export default {components: {AkLayout}}
</script>
<template>
  <AkLayout>
    <RouterView :key="$route.fullPath"/>
  </AkLayout>
</template>
